import React, { memo, useCallback, useContext, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import BrandCombobox from "../../shared/components/searchable-field/BrandCombobox";
import DataTable from "react-data-table-component";
import MaterialCheckbox from "../../shared/components/material-checkbox/MaterialCheckbox";
import DataTableProgressComponent from "../../shared/components/widget/DataTableProgressComponent";
import DataTableNoDataComponent from "../../shared/components/widget/DataTableNoDataComponent";
import { getClicks } from "../../actions/usersActions";
import { useLocation } from "react-router-dom";
import memoize from "memoize-one";
import { BankContext } from "../../shared/context/bank";

function Click({ customerId }) {
  const [brandId, setBrand] = useState(null);
  const [clicks, setClicks] = useState({ items: [], meta: {} });
  const [pagination, setPagination] = useState({ page: 1, per_page: 10 });
  const location = useLocation();
  
  // Use global bank selection from context
  const { selectedBank } = useContext(BankContext);

  console.log(brandId, 'brandId')

  const getClicksAction = useCallback(async (params) => {
    const request = await getClicks(params);
    setClicks(request);
  }, []);

  useEffect(() => {
    if (selectedBank) {
      getClicksAction({
        bank_id: selectedBank,
        ...(customerId ? { "search[customer]": customerId } : {}),
        'search[customer]': customerId,
        ...pagination,
        ...((customerId && brandId) ? { "search[brand]": brandId } : {}),
      });
    }
  }, [pagination?.page, pagination["per_page"], selectedBank, customerId, brandId, getClicksAction]);

  const columns = memoize((customerId) => [
    {
      name: "ID",
      selector: "id",
      sortable: false,
      grow: 0,
    },
    !customerId && {
      name: "user ID",
      selector: "id",
      sortable: false,
      grow: 0,
      cell: (row) => row?.customer_id,
    },
    {
      name: "Date",
      selector: "created_at",
      sortable: false,
      grow: 1,
      cell: (row) => row?.created_at?.split("T")[0],
    },
    {
      name: "Partner",
      selector: "brand",
      sortable: false,
      grow: 1,
      cell: (row) => row.brand.name,
    },
  ].filter(Boolean));

  const { items, meta } = clicks;

  return (
    <Row>
      <Col xs="12" lg="12">
        <Card>
          <CardHeader>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <i className="fa fa-align-justify"></i> Clicks list
              </div>

              <div>
                {customerId && (
                  <BrandCombobox
                    onChange={(name, id) => setBrand(id)}
                    className="w-200"
                  />
                )}
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <DataTable
              noHeader={false}
              data={items}
              columns={columns(customerId)}
              theme="solarized"
              progressPending={false}
              pagination
              paginationServer
              paginationTotalRows={meta?.total_items}
              paginationRowsPerPageOptions={[10, 15, 30, 50]}
              onChangeRowsPerPage={(e) =>
                setPagination((item) => ({ ...item, per_page: e }))
              }
              onChangePage={(e) =>
                setPagination((item) => ({ ...item, page: e }))
              }
              // onSort={this.handleSort}
              sortServer
              selectableRows
              selectableRowsComponent={MaterialCheckbox}
              // selectableRowsComponentProps={selectProps}
              // onSelectedRowsChange={handleChange}
              progressComponent={<DataTableProgressComponent />}
              noDataComponent={<DataTableNoDataComponent />}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default memo(Click);
